import React from 'react'
import { ICONS } from '@Const/common'
import Button from '@Components/Buttons/Button'
import clsx from 'clsx'
import './index.scss'
import { AutoCompleteFetcher } from '@App/stores/search/models/select-option-hide'
import AutoCompleteInput from '@Components/Search/AutoCompleteInput'
import { ChangeEvent } from 'react-autosuggest'

interface SearchWithAutoCompleteProps {
    id: string
    placeholder: string
    onClearInput(): void
    buttonClick(value: string): void
    autoCompleteFetcher: AutoCompleteFetcher
    autoCompleteField: string
    onChangeInput?: (value: string, id: string) => void
    value?: string
    searchDisabled?: boolean
    searchFieldClicked?: () => void
}

const SearchWithAutoComplete = ({
    value = '',
    onChangeInput,
    id,
    placeholder,
    buttonClick,
    searchFieldClicked,
    onClearInput,
    searchDisabled,
    autoCompleteFetcher,
    autoCompleteField,
}: SearchWithAutoCompleteProps) => {
    const [inputValue, setInputValue] = React.useState(value)

    const handleChange = (event: React.FormEvent<HTMLElement>, params: ChangeEvent) => {
        setInputValue(params.newValue)
        if (onChangeInput) {
            onChangeInput(params.newValue, id)
        }
    }

    const clickButton = () => {
        buttonClick(inputValue)
    }

    const cleanChange = () => {
        setInputValue('')
        onClearInput()
    }

    const onSelectedSuggestion = (suggestion: string) => {
        setInputValue(suggestion)
        if (onChangeInput) {
            onChangeInput(suggestion, id)
        }
    }

    const classNames = clsx('search-field-component', 'main-color-set', inputValue && 'filled')

    return (
        // I left data-testid with old name for backward compatibility with tests
        <div className={classNames} data-testid={'search-with-filter-' + id}>
            <div className="input-wrapper">
                <AutoCompleteInput
                    inputName={id}
                    onSelectedSuggestion={onSelectedSuggestion}
                    autoCompleteFetcher={autoCompleteFetcher}
                    autoCompleteField={autoCompleteField}
                    onChange={handleChange}
                    value={inputValue}
                    placeholder={placeholder}
                    onClick={searchFieldClicked}
                    onEnter={clickButton}
                />
                {inputValue && <img onClick={cleanChange} className="remove-value" src={ICONS.close} alt="close" />}
                <Button
                    onlyIcon
                    mainColor
                    type="primary"
                    icon={ICONS.search}
                    disabled={searchDisabled}
                    iconAltText="Search Works"
                    onClick={clickButton}
                />
            </div>
        </div>
    )
}

export default SearchWithAutoComplete
